/* eslint-disable indent */
import React from "react";
import { NOTA_DEFINICION_EBITDA, NOTA_INTERESES_FACTORING } from "../constants";
import styles from "../stylesERv2.module.scss";

export const EBITDAResultadoTable = ({
  modoCombinado,
  monthsToShow,
  formatCurrency,
  porcentajeSobreFacturacion,
  ebitCollapsed,
  setEbitCollapsed,
  depreciacionMensual,
  amortizacionMensual,
  meses,
  resultadoCollapsed,
  setResultadoCollapsed,
  vInteresesLocal,
  interesesWindowedMensualUSD,
  onDetalleIntereses,
  verChileYPeru,
  verEnDolares,
  pais,
  moneda,
  verUltimos12Meses,
  ebitdaMensualWindowed,
  facturacionMensualWindowed,
  filas,
  filasCombinado,
  vEbitdaUSD,
  vEbitLocalTodos,
  vEbitUSDTodos,
  vBeneficioNetoLocalTodos,
  vBeneficioNetoUSDTodos,
  vDepreciacionUSD,
  vAmortizacionUSD,
  vInteresesUSD,
  vInteresesLocalCriterio1Chile,
}) => (
  <>
    {/* === EBITDA === */}
    <tr className={styles.ebitdaRow}>
      <td className={styles.conceptCellMargen}>
        <span title={NOTA_DEFINICION_EBITDA} className={styles.infoIconEbitda}>
          EBITDA
        </span>
      </td>
      {Array(12)
        .fill(0)
        .map((_, i) => {
          if (i >= monthsToShow) return <td key={i}>-</td>;
          // FASE E2b: modo combinado (Sumar Perú) lee de `filasCombinado` (fuente única,
          // Chile+Perú fila por fila) — nunca una resta aparte con los arrays combinados sueltos.
          if (modoCombinado) {
            const ebitda = filasCombinado.EBITDA.usd[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i, null, true)}</div>
              </td>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": `vEbitdaUSD`/
          // `filas.EBITDA.usd` ya son bottom-up (Σ de las filas hoja de A-D ya convertidas,
          // nunca una reconversión de EBITDA en pesos) — Perú sigue con el camino de siempre
          // (10.265/10.267), sin cambio.
          if (pais === "Chile" && verEnDolares) {
            const ebitdaUsd = (verUltimos12Meses ? vEbitdaUSD : filas.EBITDA.usd)?.[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitdaUsd < 0 ? styles.marginNegative : ""}>
                  {formatCurrency(ebitdaUsd, i, null, true)}
                </div>
              </td>
            );
          }
          // Modo ventana: usar array pre-computado
          if (verUltimos12Meses) {
            const ebitda = ebitdaMensualWindowed[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
              </td>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única), nunca recalcula.
          const ebitda = filas.EBITDA.local[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
            </td>
          );
        })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitdaComb = filasCombinado.EBITDA.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((ebitdaComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaComb, null, null, true)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 3 (criterio 1), punto 4 — Chile + "Ver en US$": monto bottom-up; el %
          // se sigue midiendo en pesos (invariante de moneda, mismo criterio que Software DS/
          // Contribución más arriba en este mismo encargo) — nunca se reconvierte EBITDA.
          if (pais === "Chile" && verEnDolares) {
            const ebitdaYTDPeso = (verUltimos12Meses ? ebitdaMensualWindowed : filas.EBITDA.local)
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const ebitdaYTDUsd = (verUltimos12Meses ? vEbitdaUSD : filas.EBITDA.usd)
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            return (
              <div className={ebitdaYTDPeso < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaYTDUsd, null, null, true)} | {porcentajeSobreFacturacion(ebitdaYTDPeso)}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados
          if (verUltimos12Meses) {
            const ebitdaYTD = ebitdaMensualWindowed.reduce((a, b) => a + b, 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((ebitdaYTD / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaYTD < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaYTD, null, ebitdaMensualWindowed)} | {pct}
              </div>
            );
          }
          // Modo normal — FASE E2a: lee de `filas` (fuente única).
          const ebitdaYTD = filas.EBITDA.local.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          return (
            <div className={ebitdaYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ebitdaYTD, null, filas.EBITDA.local)} | {porcentajeSobreFacturacion(ebitdaYTD)}
            </div>
          );
        })()}
      </td>
    </tr>
    {/* Depreciación y Amortización (colapsables desde EBIT) */}
    {!ebitCollapsed && (
      <>
        <tr>
          <td className={styles.conceptCell}>Depreciación</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            if (modoCombinado) {
              return (
                <td key={i} className="text-end">
                  {formatCurrency(filasCombinado.Depreciación.usd[i], null, null, true)}
                </td>
              );
            }
            // FASE 3 PASO 4 (criterio 1), punto 2a — Chile + "Ver en US$": bottom-up, Criterio
            // 1b (TC promedio del mes), ya ventaneado para LTM (`vDepreciacionUSD`). El peso NO
            // cambia (sigue siendo `depreciacionMensual`/`filas["Depreciación"].local`).
            if (pais === "Chile" && verEnDolares) {
              const depreciacionUsd = (verUltimos12Meses ? vDepreciacionUSD : filas["Depreciación"].usd)?.[i] || 0;
              return (
                <td key={i} className="text-end">
                  {formatCurrency(depreciacionUsd, null, null, true)}
                </td>
              );
            }
            // LTM (E2b, sin tocar acá): esta fila nunca tuvo rama propia de ventana — el
            // prop `depreciacionMensual` YA llega windowed desde `index.js` (`vDepreciacion`)
            // cuando `verUltimos12Meses` está prendido. Modo normal (E2a): lee de `filas`.
            return (
              <td key={i} className="text-end">
                {formatCurrency(verUltimos12Meses ? depreciacionMensual[i] : filas["Depreciación"].local[i], i)}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              if (modoCombinado) {
                return formatCurrency(
                  filasCombinado.Depreciación.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                  null,
                  null,
                  true
                );
              }
              if (pais === "Chile" && verEnDolares) {
                const serieUsd = verUltimos12Meses ? vDepreciacionUSD : filas["Depreciación"].usd;
                const totalUsd = (serieUsd || []).slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return formatCurrency(totalUsd, null, null, true);
              }
              if (verUltimos12Meses) {
                return formatCurrency(
                  depreciacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  depreciacionMensual
                );
              }
              return formatCurrency(
                filas["Depreciación"].local.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                null,
                filas["Depreciación"].local
              );
            })()}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Amortización</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            if (modoCombinado) {
              return (
                <td key={i} className="text-end">
                  {formatCurrency(filasCombinado.Amortización.usd[i], null, null, true)}
                </td>
              );
            }
            // FASE 3 PASO 4 (criterio 1), punto 2a — mismo caso que Depreciación arriba.
            if (pais === "Chile" && verEnDolares) {
              const amortizacionUsd = (verUltimos12Meses ? vAmortizacionUSD : filas["Amortización"].usd)?.[i] || 0;
              return (
                <td key={i} className="text-end">
                  {formatCurrency(amortizacionUsd, null, null, true)}
                </td>
              );
            }
            // LTM (E2b, sin tocar acá): mismo caso que Depreciación arriba.
            return (
              <td key={i} className="text-end">
                {formatCurrency(verUltimos12Meses ? amortizacionMensual[i] : filas["Amortización"].local[i], i)}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              if (modoCombinado) {
                return formatCurrency(
                  filasCombinado.Amortización.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0),
                  null,
                  null,
                  true
                );
              }
              if (pais === "Chile" && verEnDolares) {
                const serieUsd = verUltimos12Meses ? vAmortizacionUSD : filas["Amortización"].usd;
                const totalUsd = (serieUsd || []).slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return formatCurrency(totalUsd, null, null, true);
              }
              if (verUltimos12Meses) {
                return formatCurrency(
                  amortizacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  amortizacionMensual
                );
              }
              return formatCurrency(
                filas["Amortización"].local.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                null,
                filas["Amortización"].local
              );
            })()}
          </td>
        </tr>
      </>
    )}

    {/* === EBIT (clickeable) === */}
    <tr
      className={styles.ebitRow}
      onClick={() => setEbitCollapsed(!ebitCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Operativo | EBIT {ebitCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // FASE E2b: modo combinado lee de `filasCombinado` (fuente única).
        if (modoCombinado) {
          const ebit = filasCombinado["Beneficio Operativo | EBIT"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, null, null, true)}</div>
            </td>
          );
        }
        // FASE 3 PASO 4b, punto 1c — `vEbitLocalTodos`/`vEbitUSDTodos` ya resuelven directo vs
        // LTM por dentro (ventaneando `filas`/`filasAnoAnterior`, fuente única) — un solo camino
        // para los 2 países, nunca un top-down aparte.
        const ebit = (verEnDolares ? vEbitUSDTodos : vEbitLocalTodos)?.[i] || 0;
        return (
          <td key={i} className="text-end">
            <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, null, null, true)}</div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitComb = filasCombinado["Beneficio Operativo | EBIT"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((ebitComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitComb, null, null, true)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 4b, punto 1c — el % siempre se mide en pesos (invariante de moneda, ya
          // establecido en EBITDA más arriba); el monto mostrado sigue el toggle "Ver en US$".
          const ebitYTDPeso = (vEbitLocalTodos || []).slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          const ebitYTDUsd = (vEbitUSDTodos || []).slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
          const ebitYTD = verEnDolares ? ebitYTDUsd : ebitYTDPeso;
          return (
            <div className={ebitYTDPeso < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ebitYTD, null, null, true)} | {porcentajeSobreFacturacion(ebitYTDPeso)}
            </div>
          );
        })()}
      </td>
    </tr>

    {/* Intereses e Impuestos (colapsables desde Resultado) */}
    {!resultadoCollapsed && (
      <>
        <tr>
          <td className={styles.conceptCell}>
            <span title={NOTA_INTERESES_FACTORING} style={{ cursor: "help" }}>
              Intereses
            </span>
          </td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // La celda del mes abre el detalle de intereses (mismo patrón que las líneas de
            // costo): el valor NO cambia, solo se envuelve en un div clickeable.
            const celdaProps = {
              onClick: () => onDetalleIntereses?.abrir(i, meses[i]),
              style: { cursor: "pointer" },
            };
            // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
            if (verChileYPeru) {
              const formatted = Math.round(filasCombinado.Intereses.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>US$ {formatted}</div>
                </td>
              );
            }
            // Modo ventana (LTM) — FASE E2c: nunca tuvo rama propia, mostraba el valor SIN
            // ventana (modo normal) aunque el TOTAL de Intereses ya restaba el valor correcto
            // por dentro. US$ precomputado con `vTC` (H5), nunca `formatCurrency(valor, i)` con
            // el TC crudo del índice.
            if (verUltimos12Meses) {
              // FASE 3 PASO 4 (criterio 1), punto 2b/2c — Chile: bottom-up ya ventaneado
              // (`vInteresesUSD`/`vInteresesLocalCriterio1Chile`). Perú sigue con el criterio
              // de hoy (10.265/10.267).
              if (pais === "Chile" && verEnDolares) {
                const formatted = Math.round(vInteresesUSD?.[i] || 0).toLocaleString("es-CL");
                return (
                  <td key={i} className="text-end">
                    <div {...celdaProps}>US$ {formatted}</div>
                  </td>
                );
              }
              if (pais === "Chile") {
                const formatted = Math.round(vInteresesLocalCriterio1Chile?.[i] || 0).toLocaleString("es-CL");
                return (
                  <td key={i} className="text-end">
                    <div {...celdaProps}>
                      {moneda(pais)}
                      {formatted}
                    </div>
                  </td>
                );
              }
              if (verEnDolares) {
                const formatted = Math.round(interesesWindowedMensualUSD[i] || 0).toLocaleString("es-CL");
                return (
                  <td key={i} className="text-end">
                    <div {...celdaProps}>US$ {formatted}</div>
                  </td>
                );
              }
              const formatted = Math.round(vInteresesLocal[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>
                    {moneda(pais)}
                    {formatted}
                  </div>
                </td>
              );
            }
            // País local — FASE E2a: lee de `filas` (fuente única).
            if (verEnDolares) {
              const formatted = Math.round(filas.Intereses.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  <div {...celdaProps}>US$ {formatted}</div>
                </td>
              );
            }
            // Moneda local
            const interesesLocal = filas.Intereses.local[i] || 0;
            const formatted = Math.round(interesesLocal).toLocaleString("es-CL");
            return (
              <td key={i} className="text-end">
                <div {...celdaProps}>
                  {moneda(pais)}
                  {formatted}
                </div>
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
              if (verChileYPeru) {
                const totalUSD = filasCombinado.Intereses.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Modo ventana (LTM) — FASE E2c.
              if (verUltimos12Meses) {
                if (pais === "Chile" && verEnDolares) {
                  const totalUSD = (vInteresesUSD || []).slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  return `US$ ${totalUSD.toLocaleString("es-CL")}`;
                }
                if (pais === "Chile") {
                  const totalLocal = (vInteresesLocalCriterio1Chile || [])
                    .slice(0, monthsToShow)
                    .reduce((sum, v) => sum + (v || 0), 0);
                  return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
                }
                if (verEnDolares) {
                  const totalUSD = interesesWindowedMensualUSD.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  return `US$ ${totalUSD.toLocaleString("es-CL")}`;
                }
                const totalLocal = vInteresesLocal.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
                return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
              }
              // País local — FASE E2a: lee de `filas` (fuente única).
              if (verEnDolares) {
                const totalUSD = filas.Intereses.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Moneda local
              const totalLocal = filas.Intereses.local.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Impuestos</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
            if (verChileYPeru) {
              const formatted = Math.round(filasCombinado.Impuestos.usd[i] || 0).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  US$ {formatted}
                </td>
              );
            }
            // País local — FASE E2a: lee de `filas` (fuente única).
            if (verEnDolares) {
              return (
                <td key={i} className="text-end">
                  US$ {Math.round(filas.Impuestos.usd[i] || 0).toLocaleString("es-CL")}
                </td>
              );
            }
            // Moneda local
            const impuestosLocal = filas.Impuestos.local[i] || 0;
            return (
              <td key={i} className="text-end">
                {moneda(pais)}
                {Math.round(impuestosLocal).toLocaleString("es-CL")}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: FASE E2b, lee de `filasCombinado` (fuente única).
              if (verChileYPeru) {
                const totalUSD = filasCombinado.Impuestos.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // País local — FASE E2a: lee de `filas` (fuente única).
              if (verEnDolares) {
                const totalUSD = filas.Impuestos.usd.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Moneda local
              const totalLocal = filas.Impuestos.local.slice(0, monthsToShow).reduce((sum, v) => sum + (v || 0), 0);
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
      </>
    )}

    {/* === RESULTADO (clickeable) === */}
    <tr
      className={styles.resultadoRow}
      onClick={() => setResultadoCollapsed(!resultadoCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Neto {resultadoCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // FASE E2b: modo combinado lee de `filasCombinado` (fuente única).
        if (modoCombinado) {
          const resultado = filasCombinado["Beneficio Neto"].usd[i] || 0;
          return (
            <td key={i} className="text-end">
              <div className={resultado < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultado, null, null, true)}
              </div>
            </td>
          );
        }
        // FASE 3 PASO 4b, punto 1c — `vBeneficioNetoLocalTodos`/`vBeneficioNetoUSDTodos` ya
        // resuelven directo vs LTM por dentro (ventaneando `filas`/`filasAnoAnterior`, fuente
        // única) — un solo camino para los 2 países, nunca un top-down aparte.
        const resultado = (verEnDolares ? vBeneficioNetoUSDTodos : vBeneficioNetoLocalTodos)?.[i] || 0;
        return (
          <td key={i} className="text-end">
            <div className={resultado < 0 ? styles.marginNegative : ""}>
              {formatCurrency(resultado, null, null, true)}
            </div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact = filasCombinado.FACTURACIÓN.usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const resultadoComb = filasCombinado["Beneficio Neto"].usd
              .slice(0, monthsToShow)
              .reduce((a, b) => a + (b || 0), 0);
            const pct = totalFact > 0 ? ((resultadoComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={resultadoComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoComb, null, null, true)} | {pct}
              </div>
            );
          }
          // FASE 3 PASO 4b, punto 1c — el % siempre se mide en pesos.
          const resultadoYTDPeso = (vBeneficioNetoLocalTodos || [])
            .slice(0, monthsToShow)
            .reduce((a, b) => a + (b || 0), 0);
          const resultadoYTDUsd = (vBeneficioNetoUSDTodos || [])
            .slice(0, monthsToShow)
            .reduce((a, b) => a + (b || 0), 0);
          const resultadoYTD = verEnDolares ? resultadoYTDUsd : resultadoYTDPeso;
          return (
            <div className={resultadoYTDPeso < 0 ? styles.marginNegative : ""}>
              {formatCurrency(resultadoYTD, null, null, true)} | {porcentajeSobreFacturacion(resultadoYTDPeso)}
            </div>
          );
        })()}
      </td>
    </tr>
  </>
);
